'use client';
import { createContext, useContext } from 'react';

export const PwaContext = createContext<boolean>(false);

export function useIsPwa() {
    return useContext(PwaContext);
}
